<template>
    <layout>
    <div class='main-page-container'>
        <div class="content">
        <div style='display:flex'>
            <div>
                <span style='color:#888; font-size:15px; margin-right:10px;margin-left:10px;'>Choose Domain</span>
                <el-select @change='onDomainChange()' v-model='selectedDomain' style='min-width:200px;'>
                    <el-option v-for='domain of domains' :label='domain' :value='domain' :key='domain'></el-option>
                </el-select>
            </div>
            <div style='text-align:right; flex:1'>
          
            <el-button @click='createClick()' size='small' icon='el-icon-plus'>Create Account</el-button>
            <el-button @click='logoutClick()' type='danger' size='small'>Logout</el-button>
            </div>
        </div>
        <div style='text-align:right;margin-top:10px; color:#888; font-size:14px;margin-right:10px;'>
            You have total {{items.length}} email account
        </div>

        <el-table 
            class='datagrid'
            height='100%'
            empty-text="No Record Found"
            :data="items.filter(data => !search || data.email.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%">
                <el-table-column
                    prop="email"
                    sortable
                    label="Email Address">

                </el-table-column>

                <el-table-column
                    sortable
                    prop="diskusedpercent"
                    label="Disk Used (%)">
                </el-table-column>

                <el-table-column
                fixed="right"
                label="">
            <template slot="header" slot-scope="scope">
                 
                        <el-input
                        class='search'
                        v-model="search"
                        size="mini"
                        style='float:right'
                        placeholder="Type to search"/>
                        <button v-if='search.length > 0' class='btn-delete' @click='search =""'>&times;</button>
                    
                </template>
                <template slot-scope="scope" >
                   <el-dropdown>
                    <el-button type="text">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native='editClick(scope.row)'>Change Password</el-dropdown-item>
                        <el-dropdown-item @click.native='deleteClick(scope.row)'>Delete Account</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </template>
                </el-table-column>
            </el-table>


            <el-dialog :title="mode == 'create' ? 'Create Email Account' : 'Change Password'" :visible.sync="showDialog">
                            <div style='margin-bottom:30px;'>
                A good password should be at least 6 - 8 characters long and should include at least two uppercase letters, lowercase letters and numbers. 
                <br><br>
                An example of a secure password would be something like this: Hgs3@4j55nKX!sl
            </div>
            <el-form :model="form">
                <el-form-item label="Email Account" v-if='mode == "create"'>
                    <div style='display:flex'>
                    <el-input v-model="form.email" autocomplete="off" placeholder='Please enter email account'></el-input>
                        <div style='width: 250px;
    margin-left: 10px;'>@{{selectedDomain}}</div>
                    </div>
                </el-form-item>
                <input type="hidden" v-else :value='form.email'>
                <el-form-item label="Password">
                    <div style='display:flex'>
                        <el-input v-model="form.password" type='password' placeholder='Please enter password' autocomplete="off"></el-input>
                    </div>
                </el-form-item>
            </el-form>
            

            <div style='height:20px; color:red;'>
                {{error}}
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">Cancel</el-button>
                <el-button :disabled="loading" type="primary" @click="confirmCreate()">Save Changes</el-button>
            </span>
            </el-dialog>
             </div>
    </div>
    </layout>
</template>

<script>
export default {
    components:{
        "layout": require('./Layout.vue').default
    },
    data(){
        return {
                config: null,
                items: [],
                showDialog: false,
                error: '',
                loading: false,
                secret: null,
                domains: [],
                selectedDomain : null,
                mode : 'create',
                search:'',
                form: {
                    email: '',
                    password: ''
                }
        }
    },
    methods:{
        async confirmCreate(){
            this.loading = true;

            let res= await $.post(`${this.config.api}?type=${this.mode}-email&secret=${this.secret}&domain=${this.selectedDomain}`, {
                 email: this.form.email,
                 password: this.form.password
             }, {} ,'JSON');

            this.loading = false;

            if(res.status == 0)
                this.error = res.errors.join(', ');
            else{
                this.error = '';
                this.showDialog = false;
                 this.load();
                this.$notify({
                    title: 'Success',
                    message:  this.mode == 'create' ? 'Email Account updated' : 'Email Account updated',
                    type: 'success'
                });
            }
      
        },

        onDomainChange(){
            this.load();
        },

        logoutClick(){
             this.$confirm("Are you sure you want to logout ?", 'Logout', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(async () => {
                    this.secret = null;
                    app.secret = false;
                    this.$router.replace({name: 'login'});   
            });  
        },



        deleteClick(data){

            this.$confirm(`This will permanently delete the email account for user "${data.email}". Continue?`, 'Delete Email Account', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(async () => {
                try {
                    let res= await $.post(`${this.config.api}?type=delete-email&secret=${this.secret}&domain=${this.selectedDomain}`, {
                        email: data.user
                    }, {} ,'JSON');

                    this.load();

                  this.$notify({
                        title: 'Success',
                        message: 'Email Account deleted',
                        type: 'success'
                  });
                } catch (error) {
                     this.$notify({
                        title: 'Unable delete email account',
                        message: 'Unable delete email account',
                        type: 'success'
                    });
                }
                   
                    

            });


        }, //end delete


        editClick(item){
             this.mode = 'edit';
             this.error = '';
             this.showDialog = true;
             this.form = {
                 email: item.user,
                 password: ''
            };
        },

        createClick(){
                this.mode = 'create';
                this.error = '';
                this.showDialog = true;
                this.form = {
                     email: '',
                        password: ''
                };
        },

        async load(){
            app.$emit('show-loading');
            let emailRes = await $.get(`${this.config.api}?type=get-emails&secret=${this.secret}&domain=${this.selectedDomain}`, {}, {} ,'JSON');
            this.items = emailRes.data.data;
             app.$emit('hide-loading');
        }
    },

    mounted(){

        
        $(async ()=>{



            if(app.secret == undefined || !app.secret){
                this.$router.replace({name: 'login'});
            }else{
                let res= await $.get('./static/config.json', {}, 'JSON');

                this.secret = app.secret;
                    //let res = await axios.get();
                this.config = res;
                this.domains = app.domains;
                this.selectedDomain = app.domains[0];
                
                this.load();
            }

          
          
        });
       
    }
}
</script>

<style lang="scss">
    .main-page-container{
        height:100%;
        .content{
            padding:20px;
            height:85%;
        }


        .datagrid {
            height:100% !important;
            td:last-child{
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
            }
        }

        .search{
            padding:0px;
            input{
                border-radius:0px;
            }
        }


        .btn-delete{
        z-index: 99999;
            position: absolute;
            right: 15px;
            top: 12px;
            background: rgba(0,0,0,.3);
            color: #FFF;
            border-radius: 30px;
            border: none;
            font-size: 15px;
            font-weight: bold;
            padding: 3px;
            line-height: 10px;
            cursor:pointer;
        }


        .el-form-item__label{
            width: 110px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main.vue